module.exports = __webpack_public_path__ + "img/synchronizacja.ddbad238.svg";